import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCRest } from "../../../../js/lib/rest/REST";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";

/**
 * @deprecated but still used by LandingPageConfigView, PrintBase, 
 */
export const ListsClientManager = (function () {
  // used by LandingPageConfigView
  TLCEventManager.addListener(
    LS2PAC_CONSTANTS.Events.onGetStaticConfigLists,
    function () {
      _getConfigLists(
        "static",
        LS2PAC_CONSTANTS.Events.onGetStaticConfigListsResponse
      );
    }
  );

  // used by LandingPageConfigView
  TLCEventManager.addListener(
    LS2PAC_CONSTANTS.Events.onGetDynamicConfigLists,
    function () {
      _getConfigLists(
        "dynamic",
        LS2PAC_CONSTANTS.Events.onGetDynamicConfigListsResponse
      );
    }
  );

  // used by LandingPageConfigView
  var _getConfigLists = function (type, callbackEvent, callback) {
    var success = false,
      lists = [],
      firstResult = 0,
      maxResults = 1000000,
      sortType = "Name";
    //TODO constants rest url

    TLCRest.jsonCall(
      ["lists", type, "config", firstResult, maxResults, sortType].join("/"),
      {
        callback: function (data) {
          success = true;
          lists = data;
        },
        finallyHandler: function () {
          if (callbackEvent !== null) {
            TLCEventManager.fireEvent(callbackEvent, {
              success: success,
              lists: lists,
            });
          }
          if (callback !== undefined) {
            callback(lists);
          }
        },
        timeout: 20000,
        cancellable: true,
        cache: false,
      }
    );
  };

  // used by PrintBase
  TLCEventManager.addListener(
    LS2PAC_CONSTANTS.Events.onGetFullListsForBibExport,
    function (event) {
      var listId = event.list.id,
        totalResourceCount = event.list.resourceCount,
        start = 0,
        quantity = 20,
        wholeList = [];

      // totalResourceCount / quantity = total calls

      var combineList = function (subset, success) {
        totalResourceCount = event.list.resourceCount;
        wholeList = wholeList.concat(subset.resources);
        if (wholeList.length < totalResourceCount && success) {
          TLCEventManager.fireEvent(
            LS2PAC_CONSTANTS.Events.onGetFullListsForBibExportUpdate,
            {
              success: success,
              data: { total: totalResourceCount, current: wholeList.length },
            }
          );
          getListData(listId, wholeList.length, quantity, combineList);
        } else {
          TLCEventManager.fireEvent(
            LS2PAC_CONSTANTS.Events.onGetFullListsForBibExportUpdate,
            {
              success: success,
              data: { total: totalResourceCount, current: wholeList.length },
            }
          );
          TLCEventManager.fireEvent(
            LS2PAC_CONSTANTS.Events.onGetFullListsForBibExportResponse,
            { success: success, data: wholeList }
          );
        }
      };
      getListData(listId, start, quantity, combineList);
    }
  );

  // used by PrintBase
  var getListData = function (id, start, quantity, callback) {
    var response,
      success = false;
    TLCRest.jsonCall(
      [
        LS2PAC_CONSTANTS.restUrls.getStaticListContent,
        id,
        start,
        quantity,
        "Title",
      ].join("/"),
      {
        callback: function (data) {
          success = true;
          response = data;
        },
        finallyHandler: function () {
          callback(response, success);
        },
      }
    );
  };

  return {};
})();
